import styled from "styled-components";
import { SolutionColors } from "@smartsuite/types/lib/constants/color";
import { GrayColors } from "@smartsuite/types";

export const DescriptionList = styled.div`
  margin: auto;
  margin-bottom: 3px;

  .error {
    input,
    .single-select,
    .react-input-group {
      border: 1px solid ${SolutionColors.basePrimaryRed} !important;
      border-radius: 5px;
    }
  }
`;

export const ErrorMessage = styled.div`
  color: ${SolutionColors.basePrimaryRed};
  position: relative;
  top: -10px;
  font-size: 13px;
`;

export const ModalContent = styled.div`
  padding: 30px 30px 10px 30px;
  background-color: ${GrayColors["G-0-5"]};
`;

export const FooterError = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
`;

export const FooterErrorText = styled.div`
  color: ${SolutionColors.basePrimaryRed};
  margin-left: 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;
